import { Button as SemanticButton } from 'semantic-ui-react';
import React from 'react';

const DiscountCodeKindButton = ({ form }) => (
  <SemanticButton.Group
    style={{
      display: 'flex',
      alignItems: 'center'
    }}
  >
    <SemanticButton
      type="button"
      style={{
        height: '40px',
        borderRadius: '16px 0 0 16px',
        cursor: 'pointer',
        fontSize: '1rem',
        color:
          form.values.kind === 'percentage' || !form.values.kind
            ? '#fff'
            : 'rgba(0,0,0,0.8)',
        backgroundColor:
          form.values.kind === 'percentage' || !form.values.kind
            ? '#6586ff'
            : 'rgba(0,0,0,0.1)'
      }}
      onClick={(e) => {
        e.preventDefault();
        form.setFieldValue('kind', 'percentage');
      }}
      positive={form.values.kind === 'percentage' || !form.values.kind}
    >
      %
    </SemanticButton>
    <SemanticButton
      style={{
        height: '40px',
        borderRadius: '0 16px 16px 0',
        cursor: 'pointer',
        fontSize: '1rem',
        color: form.values.kind === 'amount' ? '#fff' : 'rgba(0,0,0,0.8)',
        backgroundColor:
          form.values.kind === 'amount' ? '#6586ff' : 'rgba(0,0,0,0.1)'
      }}
      type="button"
      onClick={(e) => {
        e.preventDefault();
        form.setFieldValue('kind', 'amount');
      }}
      positive={form.values.kind === 'amount'}
    >
      $
    </SemanticButton>
  </SemanticButton.Group>
);

export default DiscountCodeKindButton;
